<template>
    <AddOffre />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddOffre from "@/components/Offre/AddOffre.vue";
  
    export default defineComponent({
      name: "AddOffrePage",
      components: {
        
        AddOffre,
      },
    });
  </script>